export default __webpack_public_path__ + "v3.340/facebook-logo.png";